import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "content-header" }, "Dashboard", -1)
const _hoisted_2 = { class: "dashboard-container mt-5" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-3 col-md-6 flex-grow-1" }
const _hoisted_5 = { class: "col-lg-3 col-md-6" }
const _hoisted_6 = { class: "col-lg-3 col-md-6" }
const _hoisted_7 = { class: "col-lg-3 col-md-6" }
const _hoisted_8 = {
  class: "row",
  style: {"margin-top":"50px","margin-bottom":"50px"}
}
const _hoisted_9 = {
  class: "col-lg-12",
  style: {"padding-bottom":"11px"}
}
const _hoisted_10 = { class: "col col-lg-6 col-md-6 pb-3" }
const _hoisted_11 = { class: "col col-lg-6 col-md-6 pb-3" }
const _hoisted_12 = { class: "col col-lg-6 col-md-6 pb-3" }
const _hoisted_13 = { class: "col col-lg-6 col-md-6 pb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WidgetCountSummary = _resolveComponent("WidgetCountSummary")!
  const _component_Progress = _resolveComponent("Progress")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_AreaGraph = _resolveComponent("AreaGraph")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_WidgetCountSummary, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/agencies'))),
            icon: "fas fa-building",
            text: "Total Agencies",
            count: _ctx.statistics?.agency?.total,
            color: "red",
            class: "mb-3"
          }, null, 8, ["count"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_WidgetCountSummary, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/tenants'))),
            icon: "fas fa-home",
            text: "Total Tenants",
            count: _ctx.statistics?.tenant?.total,
            color: "blue",
            class: "mb-3"
          }, null, 8, ["count"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_WidgetCountSummary, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/references'))),
            icon: "fas fa-paper-plane",
            text: "Submitted Tenant References",
            count: _ctx.statistics?.reference?.submitted.total,
            color: "green",
            class: "mb-3"
          }, null, 8, ["count"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_WidgetCountSummary, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/requested-references'))),
            icon: "fas fa-envelope",
            text: "Requested Tenant References",
            count: _ctx.statistics?.reference?.requested.total,
            color: "purple",
            class: "mb-3"
          }, null, 8, ["count"])
        ])
      ]),
      _createVNode(_component_Progress, {
        max: _ctx.agentGoal,
        progress: _ctx.statistics?.agency?.total,
        style: {"margin-top":"36px"}
      }, null, 8, ["max", "progress"]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_date_picker, {
            type: "daterange",
            "unlink-panels": "",
            "range-separator": "-",
            "start-placeholder": "Start date",
            "end-placeholder": "End date",
            shortcuts: _ctx.shortcuts,
            size: "default",
            modelValue: _ctx.selectedDates,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedDates) = $event)),
            editable: false
          }, null, 8, ["shortcuts", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_AreaGraph, {
            "model-value": _ctx.formatGraphValue(_ctx.statistics?.agency?.graph),
            icon: "fas fa-building",
            color: "red",
            text: "Number of Agencies",
            count: _ctx.statistics?.agency?.graph_total
          }, null, 8, ["model-value", "count"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_AreaGraph, {
            "model-value": _ctx.formatGraphValue(_ctx.statistics?.tenant?.graph),
            icon: "fas fa-home",
            color: "blue",
            text: "Number of Tenants",
            count: _ctx.statistics?.tenant?.graph_total
          }, null, 8, ["model-value", "count"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_AreaGraph, {
            "model-value": 
              _ctx.formatGraphValue(_ctx.statistics?.reference?.submitted?.graph)
            ,
            icon: "fas fa-paper-plane",
            color: "green",
            text: "Submitted Tenant Request",
            count: _ctx.statistics?.reference?.submitted.graph_total
          }, null, 8, ["model-value", "count"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_AreaGraph, {
            "model-value": 
              _ctx.formatGraphValue(_ctx.statistics?.reference?.requested?.graph)
            ,
            icon: "fas fa-envelope",
            color: "purple",
            text: "Tenant Reference Request",
            count: _ctx.statistics?.reference?.requested?.graph_total
          }, null, 8, ["model-value", "count"])
        ])
      ])
    ])
  ]))
}